import { Box, Container } from '@material-ui/core';
import { useEffect } from 'react';
import { SWRConfig } from 'swr';

import { useCheckoutSession } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/hooks/useCheckoutSession';
import { CheckoutSessionHeader } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionHeader';
import { PaymentMethods } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethods';
import { useGetCheckoutSessionById } from '@/hooks/requests/checkoutSession/useGetCheckoutSessionById';

interface CheckoutSessionDetailProps {
  checkoutSessionId: string;
}

export const PAYMENT_INTENT_CONTAINER_ID = 'payment-intent-container';

export const CheckoutSessionDetail = ({ checkoutSessionId }: CheckoutSessionDetailProps) => {
  const { checkoutSession: cachedCheckoutSession } = useGetCheckoutSessionById(checkoutSessionId);
  const { checkoutSessionEntity, createCheckoutSessionEntity } = useCheckoutSession();

  useEffect(() => {
    if (cachedCheckoutSession) {
      createCheckoutSessionEntity();
    }
  }, [cachedCheckoutSession]);

  const checkoutSession = checkoutSessionEntity?.checkoutSession ?? cachedCheckoutSession;

  if (!checkoutSession) {
    return null;
  }

  // TODO: Add ApplicationShowSummaryMobileButton as it was removed because it was coupled to ApplicationContext

  return (
    <SWRConfig value={{ revalidateIfStale: false }}>
      <Container maxWidth={'lg'} style={{ padding: 0 }}>
        <Box display={'flex'} flexDirection={'column'} gridGap={24}>
          <CheckoutSessionHeader checkoutSession={checkoutSession} />
          <PaymentMethods checkoutSession={checkoutSession} />
        </Box>
      </Container>
      <div id={PAYMENT_INTENT_CONTAINER_ID}></div>
    </SWRConfig>
  );
};
